'use strict';

let Container = require('./container');

class AtRule extends Container {
  constructor(defaults) {
    super(defaults);
    this.type = 'atrule';
  }

  append() {
    if (!this.proxyOf.nodes) this.nodes = [];
    return super.append(...arguments);
  }

  prepend() {
    if (!this.proxyOf.nodes) this.nodes = [];
    return super.prepend(...arguments);
  }

}

module.exports = AtRule;
AtRule.default = AtRule;
Container.registerAtRule(AtRule);